export default "__VITE_ASSET__DbdILB4h__"